export function StripeIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="56" 
        height="56" 
        viewBox="0 0 56 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="8" y="7" width="41" height="41" fill="#D9D9D9"/>
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12ZM25.7591 20.8449C25.7591 19.3104 27.0182 18.7202 29.1036 18.7202C30.2109 18.7202 31.426 18.8443 32.6692 19.0824C35.5894 19.6419 38.8617 17.6302 38.8617 14.6569C38.8617 13.0479 37.8875 11.5724 36.3381 11.1385C33.9268 10.4633 31.526 10.1818 29.1036 10.1818C21.1161 10.1818 15.8042 14.3526 15.8042 21.3171C15.8042 32.177 30.7562 30.4457 30.7562 35.128C30.7562 36.938 29.1823 37.5282 26.9788 37.5282C25.596 37.5282 24.0509 37.2883 22.478 36.8743C19.5452 36.1024 16.237 38.0842 16.237 41.1169C16.237 42.7117 17.1789 44.1791 18.6967 44.6687C21.5366 45.585 24.3525 45.9879 26.9788 45.9879C35.1631 45.9879 40.7897 41.9351 40.7897 34.8919C40.7504 23.1664 25.7591 25.2518 25.7591 20.8449Z" 
          fill="#635AFF" 
        />
      </svg>
    )
  }